import { lazyWithRetry } from 'utils/chunkLoadRecovery';
import { EnhancedPath } from 'utils/history';

export class HomePagePaths {
  static home = new EnhancedPath('/');
}

const routesConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
    {
      path: HomePagePaths.home.path,
      component: lazyWithRetry(() => import('app/pages/home')),
      exact: true,
      isAllowedWithoutRoles: true,
    },
  ],
};

export default routesConfig;
